<div [formGroup]="form1">

  <!-- ── HEADER ── -->
  <div class="kbm-modal-header">
    <div>
      <div class="header-eyebrow">Providers</div>
      <h2 class="header-title">{{formTitle}}</h2>
    </div>
    <button class="close-btn" mat-dialog-close>✕</button>
  </div>

  <!-- ── BODY ── -->
  <div class="kbm-modal-body">

    <div class="kbm-section-label"><span>Provider Details</span></div>
    <div class="kbm-field-grid cols-2" style="margin-bottom:16px">
      <div class="kbm-field span-2">
        <label class="kbm-label">Company Name <span class="req">*</span></label>
        <input class="kbm-input" formControlName="name" placeholder="e.g. Trilogy Excursions"/>
        <div *ngIf="errMsg('name')" class="kbm-hint" style="color:#ef4444">{{errMsg('name')}}</div>
      </div>
      <div class="kbm-field">
        <label class="kbm-label">Category <span class="req">*</span></label>
        <select class="kbm-select" formControlName="category">
          <option value="">Select…</option>
          <option *ngFor="let c of CATEGORIES" [value]="c.value">{{c.name}}</option>
        </select>
      </div>
      <div class="kbm-field">
        <label class="kbm-label">Status</label>
        <select class="kbm-select" formControlName="status">
          <option *ngFor="let s of STATUSES" [value]="s.value">{{s.name}}</option>
        </select>
      </div>
      <div class="kbm-field span-2">
        <label class="kbm-label">Website</label>
        <input class="kbm-input" type="url" formControlName="website" placeholder="https://…"/>
      </div>
    </div>

    <div class="kbm-section-label"><span>Contact Information</span></div>
    <div class="kbm-field-grid cols-2" style="margin-bottom:16px">
      <div class="kbm-field">
        <label class="kbm-label">Main Contact <span class="req">*</span></label>
        <input class="kbm-input" formControlName="contactName" placeholder="Full name"/>
        <div *ngIf="errMsg('contactName')" class="kbm-hint" style="color:#ef4444">{{errMsg('contactName')}}</div>
      </div>
      <div class="kbm-field">
        <label class="kbm-label">Title / Role</label>
        <input class="kbm-input" formControlName="contactRole" placeholder="e.g. Reservations Manager"/>
      </div>
      <div class="kbm-field">
        <label class="kbm-label">Primary Phone <span class="req">*</span></label>
        <input class="kbm-input" type="tel" formControlName="phone" placeholder="(808) 000-0000"/>
        <div *ngIf="errMsg('phone')" class="kbm-hint" style="color:#ef4444">{{errMsg('phone')}}</div>
      </div>
      <div class="kbm-field">
        <label class="kbm-label">Secondary Phone</label>
        <input class="kbm-input" type="tel" formControlName="phone2" placeholder="Cell / after-hours"/>
      </div>
      <div class="kbm-field">
        <label class="kbm-label">Email</label>
        <input class="kbm-input" type="email" formControlName="email" placeholder="bookings@provider.com"/>
      </div>
      <div class="kbm-field">
        <label class="kbm-label">Best Time to Call</label>
        <input class="kbm-input" formControlName="bestTimeToCall" placeholder="e.g. Mon–Fri 8AM–4PM HST"/>
      </div>
    </div>

    <div class="kbm-section-label"><span>Booking Information</span></div>
    <div class="kbm-field-grid cols-2" style="margin-bottom:16px">
      <div class="kbm-field">
        <label class="kbm-label">How to Book <span class="req">*</span></label>
        <select class="kbm-select" formControlName="bookingMethod">
          <option *ngFor="let m of BOOKING_METHODS" [value]="m.value">{{m.name}}</option>
        </select>
      </div>
      <div class="kbm-field">
        <label class="kbm-label">Lead Time</label>
        <select class="kbm-select" formControlName="leadTime">
          <option *ngFor="let l of LEAD_TIMES" [value]="l.value">{{l.name}}</option>
        </select>
      </div>
      <div class="kbm-field">
        <label class="kbm-label">Online Booking URL</label>
        <input class="kbm-input" type="url" formControlName="bookingUrl" placeholder="https://…"/>
      </div>
      <div class="kbm-field">
        <label class="kbm-label">KBM Group Rate</label>
        <input class="kbm-input" formControlName="groupRate" placeholder="e.g. 10% off, Code: KBM2026"/>
      </div>
      <div class="kbm-field span-2">
        <label class="kbm-label">Staff Booking Notes <span class="req">*</span></label>
        <textarea class="kbm-textarea" formControlName="staffNotes" rows="4"
          placeholder="Detailed instructions for KBM staff…"></textarea>
        <div *ngIf="errMsg('staffNotes')" class="kbm-hint" style="color:#ef4444">{{errMsg('staffNotes')}}</div>
        <div class="kbm-hint">Internal only</div>
      </div>
      <div class="kbm-field span-2">
        <label class="kbm-label">Guest-Facing Instructions</label>
        <textarea class="kbm-textarea" formControlName="guestInstructions" rows="3"
          placeholder="Shown to guests on the concierge page…"></textarea>
      </div>
    </div>

    <div class="kbm-section-label"><span>Cancellation &amp; Payment</span></div>
    <div class="kbm-field-grid cols-2" style="margin-bottom:16px">
      <div class="kbm-field">
        <label class="kbm-label">Cancellation Policy</label>
        <select class="kbm-select" formControlName="cancellationPolicy">
          <option *ngFor="let c of CANCEL_POLICIES" [value]="c.value">{{c.name}}</option>
        </select>
      </div>
      <div class="kbm-field">
        <label class="kbm-label">Payment Methods</label>
        <input class="kbm-input" formControlName="paymentMethods" placeholder="e.g. Card on file, Cash"/>
      </div>
      <div class="kbm-field span-2">
        <label class="kbm-label">Additional Notes</label>
        <textarea class="kbm-textarea" formControlName="additionalNotes" rows="2"></textarea>
      </div>
    </div>

  </div><!-- /kbm-modal-body -->

  <!-- ── FOOTER ── -->
  <div class="kbm-modal-footer">
    <div>
      <button *ngIf="!isNew" class="btn-kbm-danger-outline btn-kbm-sm" (click)="onDelete()">Delete Provider</button>
    </div>
    <div style="display:flex;gap:8px;margin-left:auto">
      <button class="btn-kbm-outline" mat-dialog-close>Cancel</button>
      <button class="btn-kbm-primary" (click)="save()" [disabled]="formLoading">
        {{formLoading ? 'Saving…' : (isNew ? 'Add Provider' : 'Update Provider')}}
      </button>
    </div>
  </div>

</div>
